import styled from 'styled-components'

export const ZoomContainer = styled.div`
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    bottom: 25px;
    left: 50%;
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme['gray-400']};
    transform: translateX(-50%);
    background: ${({ theme }) => theme['gray-100']};
    padding: 16px;
    gap: 8px;
    overflow: hidden;

    > div {
        display: flex;
        justify-content: center;
        align-items: center;
        color: ${({ theme }) => theme['blue-500']};
        cursor: pointer;

        &.disabled {
            color: ${({ theme }) => theme['blue-300']};
            cursor: not-allowed;
        }

        input {
            appearance: none;
            background: ${({ theme }) => theme['gray-400']};
            outline: none;
            height: 2px;

            &::-webkit-slider-thumb,
            &::-moz-range-thumb {
                border: none;
                background: ${({ theme }) => theme['blue-500']};
                cursor: pointer;
            }
        }
    }
`
